import { createContext } from "react";

export type GlobalConfig = {
  backendHost: string;
  domainId: number;
  publicKey: string;
  language: string;
  currency: string;
  debug: boolean;
}

const defaultConfig = {
  backendHost: ``,
  domainId: 0,
  publicKey: ``,
  language: `en`,
  currency: `EUR`,
  debug: false,
};

const ConfigContext = createContext<GlobalConfig>(defaultConfig);

export default ConfigContext;
